module.exports = __webpack_public_path__ + "static/media/header-logo.72c3421a.png";